export const BASE_URL = 'https://server.edu-lms.sigma13.com/v1/'
export const TLDRAW_WORKER_URL = 'https://server.edu-lms.sigma13.com:5858'
